import React from 'react';
import './Message.css';

const Message = ({ message, type }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={`message ${type}`}>
      <p>{message}</p>
    </div>
  );
};

export default Message;